import { render, staticRenderFns } from "./CategoryChart.vue?vue&type=template&id=5206493a"
import script from "./CategoryChart.vue?vue&type=script&lang=ts"
export * from "./CategoryChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports